
import EoButton from '../EoButton/EoButton'
import EoIcon from '../EoIcon/EoIcon'

export default {
  name: 'EoSearchFilterChips',
  components: {
    EoButton,
    EoIcon,
  },
  props: {
    /**
     * All filters
     */
    value: {
      type: Array,
      default: () => [],
    },
    /*
     * Style: color used on buttons
     */
    buttonColor: {
      type: String,
      default: null,
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      filters: {},
    }
  },
  computed: {
    selectedFilters () {
      // Return all filters with a selected value
      if (!this.filters) return {}
      const filters = Object.entries(this.filters)
      if (filters && filters.length) {
        return filters.reduce((returnObject, [slug, filter]) => {
          if (filter.options && filter.selected) {
            returnObject[slug] = filter
          }
          return returnObject
        }, {})
      } else {
        return {}
      }
    },
  },
  watch: {
    value: {
      handler: 'onUpdatedModel',
      immediate: true,
    },
    filters: 'onUpdatedFilters',
  },
  methods: {
    onUpdatedModel () {
      this.filters = this.value
    },
    onUpdatedFilters (filters) {
      /**
       * Emitted when the filters have changed
       * @event input
       */
      this.$emit('input', filters)
    },
    getLabel (filter) {
      return filter?.options?.find((option) => {
        return option.slug === filter.selected
      }).label
    },
    deactivateFilter (slug, selection) {
      if (!this.filters) return
      if (!this.filters[slug]) return
      const remainingSelectedOptions = this.filters[slug].selected?.filter(item => item !== selection)
      this.filters[slug].selected = remainingSelectedOptions.length ? remainingSelectedOptions : null
    },
  },
}
